<template>
  <div class="BaseAccountUserDetailsPopup">
    <el-row class="py-2 pl-12 flex items-center">
      <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
        <p class="text-xs font-bold pb-1">
          Full Name <span style="color: #d64b47">*</span>
        </p>
      </el-col>
      <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
        <div class="flex">
          <BaseInput
            v-model="accountUserDetails.full_name"
            v-validate="'required'"
            :name="'Full Name' + accountUserIndex"
            style="width: 100%"
            class="baseInput"
            custom-class="p-2 text-sm text-amp-input-boxes"
            placeholder="Full Name"
          />
        </div>
        <p
          v-show="errors.has('Full Name' + accountUserIndex)"
          class="text-red-dark text-xs"
        >
          {{ errors.first("Full Name" + accountUserIndex) }}
        </p>
      </el-col>
    </el-row>
    <!-- <el-row class="py-2 pl-12 flex items-center">
			<el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
				<p class="text-xs font-bold pb-1">Last Name <span style="color: #d64b47;">*</span></p>
			</el-col>
			<el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
				<div class="flex">
					<BaseInput
						v-model="accountUserDetails.lastName"
						v-validate="'required'"
						:name="'last Name' + accountUserIndex"
						style="width: 100%;"
						class="baseInput"
						custom-class="p-2 text-sm text-amp-input-boxes"
						placeholder="Last Name"
					/>
				</div>
				<p
					v-show="errors.has('last Name' + accountUserIndex)"
					class="text-red-dark text-xs"
				>
					{{ errors.first("last Name" + accountUserIndex) }}
				</p>
			</el-col>
		</el-row> -->
    <el-row class="py-2 pl-12 flex items-center">
      <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
        <p class="text-xs font-bold pb-1">
          Designation <span style="color: #d64b47">*</span>
        </p>
      </el-col>
      <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
        <div class="flex flex-wrap">
          <!-- <BaseInput
            v-model="accountUserDetails.designation"
            v-validate="'required'"
            :name="'Designation' + accountUserIndex"
            style="width: 100%"
            class="baseInput"
            custom-class="p-2 text-sm text-amp-input-boxes"
            placeholder="Enter Designation"
          /> -->
          <el-select
            v-model="accountUserDetails.designation"
            filterable
            v-validate="'required'"
            style="width: 100%"
            placeholder="Select Designation"
            :name="'Designation' + accountUserIndex"
            size="small"
            class="capitalize"
            @input="addDesignation($event)"
            @change="selectDesignInfo(accountUserDetails.designation)"
          >
            <!-- :disabled="filter_.id ? true : false"
                    @change="getFunctionList()" -->
            <el-option label="add new" value="add new" style="color: #e29d5a"
              >Add-Edit Designation</el-option
            >
            <el-option
              v-for="(item, index) in designationList"
              :key="index"
              :value="item.id"
              :label="item.name"
              class="capitalize"
            >
              <!-- :disabled="store_name.includes('all')" -->
              {{ item.name }}
            </el-option>
          </el-select>
          <span
            v-show="errors.has('Designation' + accountUserIndex)"
            class="text-red-dark text-xs"
            >{{ errors.first("Designation" + accountUserIndex) }}</span
          >
        </div>
      </el-col>
    </el-row>
    <el-row class="py-2 pl-12 flex items-center">
      <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
        <p class="text-xs font-bold pb-1">
          Email <span style="color: #d64b47">*</span>
        </p>
      </el-col>
      <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
        <div class="flex flex-wrap">
          <BaseInput
            v-model="accountUserDetails.email"
            v-validate="'required|email'"
            :name="'Email' + accountUserIndex"
            style="width: 100%; text-transform: none"
            class="baseInput"
            custom-class="p-2 text-sm email text-amp-input-boxes"
            placeholder="Enter Email Id"
            :disabled="accountUserData != undefined"
            @change="checkValidationByAPIEmail(accountUserDetails.email)"
          />
          <span
            v-show="errors.has('Email' + accountUserIndex)"
            class="text-red-dark text-xs"
            >{{ errors.first("Email" + accountUserIndex) }}</span
          >
          <p v-if="!uniqEmail">
            <span class="text-red-dark text-xs"> Email already exists </span>
          </p>
        </div>
      </el-col>
    </el-row>
    <el-row class="py-2 pl-12 flex items-center">
      <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
        <p class="text-xs font-bold pb-1">Mobile No</p>
      </el-col>
      <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
        <div class="flex flex-wrap">
          <BaseInput
            v-model="accountUserDetails.contactNumber"
            :name="'Contact' + accountUserIndex"
            style="width: 100%"
            class="baseInput"
            custom-class="p-2 text-sm  text-amp-input-boxes"
            placeholder="Mobile No"
          />
        </div>
      </el-col>
    </el-row>
    <el-row class="py-2 pl-12 flex items-center">
      <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
        <p class="text-xs font-bold pb-1">Access Level</p>
      </el-col>
      <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
        <div v-if="accountType == 'store'" class="flex flex-wrap">
          <el-select
            v-model="accountUserDetails.access_level"
            v-validate="'required'"
            style="width: 100%"
            placeholder="Select Access"
            name="Account Type"
            @change="changesAccessLevel(accountUserDetails.access_level)"
          >
            <el-option
              label="Store User"
              value="outlet"
              :disabled="accountType == 'head_office'"
            >
              Store User
            </el-option>
            <el-option label="Staff" value="employee"> Staff </el-option>
          </el-select>
        </div>
        <div v-else class="flex flex-wrap">
          <el-select
            v-model="accountUserDetails.access_level"
            v-validate="'required'"
            style="width: 100%"
            placeholder="Select Access"
            name="Account Type"
          >
            <!-- :disabled="
              accountType == 'region' ||
              accountType == 'subregion' ||
              accountType == 'vendor'
            " -->
            <el-option
              label="Store User"
              value="outlet"
              :disabled="accountType == 'head_office'"
            >
              Store User
            </el-option>
            <el-option label="Regional User" value="region">
              Regional User
            </el-option>
            <el-option label="Sub Regional User" value="sub_region">
              Sub Regional User
            </el-option>
            <el-option label="Super" value="super"> Super </el-option>
            <el-option
              v-if="accountType == 'vendor'"
              label="Vendor"
              value="vendor"
            >
              Vendor
            </el-option>
            <el-option label="Admin" value="admin"> Admin </el-option>
          </el-select>
        </div>
      </el-col>
    </el-row>
    <el-row
      v-if="
        checkPopup == '' &&
        (accountUserDetails.access_level == 'region' ||
          accountUserDetails.access_level == 'sub_region')
      "
      class="py-2 pl-12 flex items-center"
    >
      <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
        <p class="text-xs font-bold pb-1">Region</p>
      </el-col>
      <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
        <div class="flex">
          <el-select
            v-model="accountUserDetails.access_region"
            class="custom-input"
            placeholder="Select Region"
            style="width: 100%"
            name="Select Region"
          >
            <!-- :disabled="accountType == 'region' || accountType == 'subregion'" -->
            <!-- @change="popUpShow" -->
            <el-option
              v-for="(reg, region_index) in regions"
              :key="region_index"
              :value="reg.id"
              :label="reg.name"
            >
              {{ reg.name }}
            </el-option>
          </el-select>
        </div>
      </el-col>
    </el-row>
    <el-row
      v-if="checkPopup == '' && accountUserDetails.access_level == 'sub_region'"
      class="py-2 pl-12 flex items-center"
    >
      <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
        <p class="text-xs font-bold pb-1">Sub Region</p>
      </el-col>
      <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
        <div class="flex">
          <el-select
            v-model="accountUserDetails.access_subregion"
            class="custom-input"
            placeholder="Sub Region"
            style="width: 100%"
            name="Sub Region"
          >
            <!-- :disabled="accountType == 'subregion'" -->
            <!-- @change="popUpShow" -->
            <el-option
              v-for="(sub_reg, sub_reg_index) in subRegions"
              :key="sub_reg_index"
              :value="sub_reg.id"
              :label="sub_reg.name"
            >
              {{ sub_reg.name }}
            </el-option>
          </el-select>
        </div>
      </el-col>
    </el-row>

    <!-- <el-row :gutter="10">
    </el-row>-->

    <!-- <el-row :gutter="10">

			<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
				<p class="text-sm pt-4 pb-1 w-1/2">
					First Name
				</p>
				<BaseInput
					v-model="accountUserDetails.firstName"
					v-validate="'required'"
					:name="'First Name' + accountUserIndex"
					style="width: 100%;"
					class="baseInput"
					custom-class="p-2 text-sm text-amp-input-boxes"
					placeholder="First Name"
				/>
				<span
					v-show="errors.has('First Name' + accountUserIndex)"
					class="text-red-dark text-xs"
				>
					{{ errors.first("First Name" + accountUserIndex) }}
				</span>
			</el-col>
			<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
				<p class="text-sm pt-4 pb-1 w-1/2">
					Last Name
				</p>
				<BaseInput
					v-model="accountUserDetails.lastName"
					v-validate="'required'"
					style="width: 100%;"
					class="baseInput"
					custom-class="p-2 text-sm text-amp-input-boxes"
					placeholder="Last Name"
					:name="'Last Name' + accountUserIndex"
				/>
				<span
					v-show="errors.has('Last Name' + accountUserIndex)"
					class="text-red-dark text-xs"
				>
					{{ errors.first("Last Name" + accountUserIndex) }}
				</span>
			</el-col>
		</el-row>
		<el-row :gutter="10">
			<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
				<p class="text-sm pt-4 pb-1 w-1/2">
					Email
				</p>
				<BaseInput
					v-model="accountUserDetails.email"
					v-validate="'required|email'"
					:name="'Email' + accountUserIndex"
					style="width: 100%;"
					class="baseInput"
					custom-class="p-2 text-sm text-amp-input-boxes"
					placeholder="Email Id"
				/>
				<span
					v-show="errors.has('Email' + accountUserIndex)"
					class="text-red-dark text-xs"
				>
					{{ errors.first("Email" + accountUserIndex) }}
				</span>
			</el-col>
			<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
				<p class="text-sm pt-4 pb-1 w-1/2">
					Contact
				</p>
				<BaseInput
					v-model="accountUserDetails.contactNumber"
					:name="'Contact' + accountUserIndex"
					style="width: 100%;"
					class="baseInput"
					custom-class="p-2 text-sm  text-amp-input-boxes"
					placeholder="Mobile No"
				/>
			</el-col>
		</el-row>
		<el-row :gutter="10">
			<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
				<p class="text-sm pt-4 pb-1 w-1/2">
					Designation
				</p>
				<BaseInput
					v-model="accountUserDetails.designation"
					v-validate="'required'"
					:name="'Designation' + accountUserIndex"
					style="width: 100%;"
					class="baseInput"
					custom-class="p-2 text-sm text-amp-input-boxes"
					placeholder="Designation"
				/>
				<span
					v-show="errors.has('Designation' + accountUserIndex)"
					class="text-red-dark text-xs"
				>
					{{ errors.first("Designation" + accountUserIndex) }}
				</span>
			</el-col>
    </el-row>-->
    <div v-if="accountUserData === undefined" class="flex justify-end">
      <div
        class="buttons-parrent2"
        style="display: flex; justify-content: flex-end"
      >
        <div class="mx-4 mt-8">
          <BaseButton
            type="submit"
            style="width: 100px"
            buttonclass="btn p-2 text-xs "
            @click="$emit('closeAddBaseAccountUserPopup')"
            >Cancel</BaseButton
          >
        </div>
      </div>
      <div
        class="buttons-parrent2"
        style="display: flex; justify-content: flex-end"
      >
        <div class="mx-4 mt-8">
          <BaseButton
            type="submit"
            style="width: 100px"
            buttonclass="btn p-2 text-xs "
            @click="addMoreAccountUserData"
            >Add More</BaseButton
          >
        </div>
      </div>
      <div
        class="buttons-parrent2"
        style="display: flex; justify-content: flex-end"
      >
        <div class="mx-4 mt-8">
          <BaseButton
            type="submit"
            style="width: 100px"
            buttonclass="btn p-2 text-xs "
            @click="addAccountUserData"
            >Save</BaseButton
          >
        </div>
      </div>
    </div>
    <div v-else class="flex justify-end">
      <div
        class="buttons-parrent2"
        style="display: flex; justify-content: flex-end"
      >
        <div class="mx-4 mt-8">
          <BaseButton
            type="submit"
            style="width: 100px"
            buttonclass="btn p-2 text-xs "
            @click="$emit('closeEditBaseAccountUserPopup')"
            >cancel</BaseButton
          >
        </div>
      </div>
      <div
        class="buttons-parrent2"
        style="display: flex; justify-content: flex-end"
      >
        <div class="mx-4 mt-8">
          <BaseButton
            type="submit"
            style="width: 100px"
            buttonclass="btn p-2 text-xs "
            @click="updateAccountUserData"
            >Update</BaseButton
          >
        </div>
      </div>
    </div>

    <el-dialog
      title="Add Designation"
      :visible.sync="add_new_designation_dialog"
      width="50%"
    >
      <!-- :before-close="updateList()" -->
      <div v-loading="is_designation_list_loading">
        <div>
          <div
            id="add-designation-wrapper"
            style="height: 200px; overflow-y: auto"
          >
            <div
              v-for="(designation, designation_index) in add_designation_list"
              :key="designation_index"
              class="py-2 flex items-center"
            >
              <el-input
                v-model="designation.name"
                :placeholder="'designation ' + (designation_index + 1)"
                size="medium"
                style="width: 50%"
                type="text"
                @input="designation.isChange = true"
              />
              <div class="ml-5">
                <!-- src="../../../../assets/images/delete-icon.png" -->
                <img
                  class="cursor-pointer"
                  src="../../assets/images/delete-icon.png"
                  alt="Delete"
                  width="22px"
                  @click="deleteDesignation(designation_index)"
                />
              </div>
            </div>
          </div>

          <div class="flex items-center mt-5">
            <BaseButton
              type="submit"
              style="width: 100px"
              buttonclass="btn p-2 text-xs"
              @click="addMoreDesignation()"
            >
              Add More
            </BaseButton>
          </div>
        </div>

        <span
          slot="footer"
          class="dialog-footer flex"
          style="justify-content: flex-end"
        >
          <BaseButton
            type="submit"
            style="width: 100px"
            buttonclass="btn p-2 text-xs"
            @click="
              (add_new_designation_dialog = false), updateDesignationList()
            "
          >
            Cancel
          </BaseButton>

          <BaseButton
            type="submit"
            style="width: 100px"
            buttonclass="btn p-2 text-xs ml-2"
            @click="addUpdateDesignation()"
          >
            Update
          </BaseButton>
        </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { EventBus } from "../../eventBus";
import { serverAddr } from "../../networkConfig";

export default {
  name: "BaseAccountUserDetailsPopup",
  mixins: [],
  props: {
    accountType: {
      type: String,
      default: () => "",
    },
    accountUserData: {
      type: String,
      default: () => {},
    },
    newAccountUserData: {
      type: Object,
      default: () => {},
    },
    accountUserIndex: {
      type: Number,
      default: () => 0,
    },
    regions: {
      type: Array,
      default: () => [],
    },
    subRegions: {
      type: Array,
      default: () => [],
    },
    checkPopup: {
      type: String,
      default: () => "",
    },
    accountId: {
      type: String,
      default: () => "",
    },
  },
  data() {
    return {
      sub_region: "",
      region: "",
      uniqEmail: true,
      designationList: [],
      add_designation_list: [],
      add_new_designation_dialog: false,
      is_designation_list_loading: false,

      currentAccUserDetails: {},

      accountUserDetails: {},
      //   this.accountUserData === undefined
      //     ? this.newAccountUserData
      //     : JSON.parse(this.accountUserData),
    };
  },
  created() {
    console.log("accountType", this.accountType);
    if (this.accountUserData === undefined) {
      if (this.accountType == "vendor") {
        this.newAccountUserData.access_level = "vendor";
      } else if (this.accountType == "region") {
        this.newAccountUserData.access_level = "region";
        this.newAccountUserData.access_region = this.accountId;
      } else if (this.accountType == "subregion") {
        this.newAccountUserData.access_level = "sub_region";
        console.log(this.newAccountUserData.access_subregion);
        this.newAccountUserData.access_subregion = this.accountId;
        for (let i in this.regions) {
          for (let j in this.regions[i].subregions) {
            if (this.regions[i].subregions[j] == this.accountId) {
              this.newAccountUserData.access_region = this.regions[i].id;
            }
          }
        }
      }
      this.accountUserDetails = this.newAccountUserData;
    } else {
      if (typeof JSON.parse(this.accountUserData).access_region == 'object' || typeof JSON.parse(this.accountUserData).access_subregion == 'object') {
        let access_region = JSON.parse(this.accountUserData).access_region[0];
        let access_subregion = JSON.parse(this.accountUserData)
          .access_subregion[0];

        this.accountUserDetails = JSON.parse(this.accountUserData);
        this.accountUserDetails.access_region = access_region;
        this.accountUserDetails.access_subregion = access_subregion;
      }else{
        this.accountUserDetails = JSON.parse(this.accountUserData);
      }
        console.log('this.accountUserDetails.access_subregion', this.accountUserDetails.access_subregion);
    }

    // get designation list
    this.getDesignationList();
  },
  mounted() {
    console.log("this.accountUserDetails", this.accountUserDetails);
  },
  methods: {
   getDesignationList() {
      serverAddr
        .post(`/users/designations/list/`)
        .then((res) => {
          let response = JSON.parse(res.data);
          this.designationList = response;

          // this.accountUserDetails.designation = this.designationList[0].id
        })
        .catch((err) => {
          console.log(err);
        });
    },
    selectDesignInfo(desig) {
      this.accountUserDetails.designation = this.previous_selection;
      this.designationList.forEach((element) => {
        if (element.id == desig) {
          this.accountUserDetails.designation_info = element;
        }
      });
    },
    addDesignation(event) {
      if (event == "add new") {
        this.accountUserDetails.designation = "";
        this.add_designation_list = this.designationList.slice(0); //get shadow copy of array
        this.add_designation_list.forEach((element) => {
          if (element.id) {
            element.isChange = false;
          }
        });
        this.add_new_designation_dialog = true;
      } else {
        this.previous_selection = event;
      }
    },

    addMoreDesignation() {
      let designation = {
        name: "",
      };

      this.add_designation_list.unshift(designation);

      // to scroll to top of div after adding one more item to list
      this.scrollToTop("add-designation-wrapper");
    },

    addUpdateDesignation() {
      this.is_designation_list_loading = true; //displyed loader
      this.add_designation_list.forEach((element) => {
        if (element.name.length) {
          if (!element.id) {
            serverAddr
              .post(`/users/designations/save/`, {
                name: element.name,
              })
              .then((response) => {
                if (response.status == 200) {
                }
              })
              .catch((error) => {
                console.log(error);
              });
          } else if (element.id && element.isChange) {
            serverAddr
              .patch(`/users/designations/${element.id}/`, {
                name: element.name,
              })
              .then((response) => {
                if (response.status == 200) {
                }
              })
              .catch((error) => {
                console.log(error);
              });
          }
        }
      });

      setTimeout(() => {
        this.$notify.success({
          title: "Success",
          message: "Designation updated..!",
        });
        this.getDesignationList();
        this.is_designation_list_loading = false;
        this.add_new_designation_dialog = false;
      }, 2000);
      this.updateDesignationList();
    },
    updateDesignationList() {
      EventBus.$emit("updateDesignationList");
    },
    scrollToTop(div) {
      var objDiv = document.getElementById(div);
      objDiv.scrollTo(0, 0);
      // objDiv.scrollTop = objDiv.scrollHeight + '20px';
    },

    deleteDesignation(index) {
      this.is_designation_list_loading = true; //displyed loader
      let designation_id = this.add_designation_list[index].id;
      if (designation_id != undefined) {
        serverAddr
          .delete(`/users/designations/${designation_id}`)
          .then((response) => {
            this.add_designation_list.splice(index, 1);

            setTimeout(() => {
              this.getDesignationList();
              this.is_designation_list_loading = false; //disabld loader
              this.$notify.success({
                title: "Success",
                message: "Designation removed..!",
              });
            }, 2000);
          })
          .catch((e) => {
            console.log("error", e);
            this.is_designation_list_loading = false; //disabld loader
          });
      } else {
        this.add_designation_list.splice(index, 1);
      }
    },

    checkValidationByAPIEmail(email) {
      console.log(email);
      if (email) {
        serverAddr
          .post(`/users/status/`, {
            email: email,
          })
          .then((res) => {
            console.log(res.data);
            let response = JSON.parse(res.data);
            console.log("response");
            if (response.message == "This user is not registered") {
              this.uniqEmail = true;
              // this.$notify.warning({
              //   title: "Warning",
              //   message: response.message,
              // });
            } else {
              this.uniqEmail = false;
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    changesAccessLevel(access) {
      // this.accountUserDetails.access_level = access;
      console.log(this.accountUserDetails);
    },
    addAccountUserData() {
      this.$validator.validateAll().then((result) => {
        if (result && this.uniqEmail) {
          EventBus.$emit(
            "saveNewAccountUserData",
            this.accountUserDetails,
            this.accountUserIndex
          );
          this.$emit("closeAddBaseAccountUserPopup");
        } else {
          if (!this.uniqEmail) {
            this.$message.error("Please provide a unique email id");
          } else {
            this.$message.error("Required fields are missing");
          }
        }
      });
    },
    addMoreAccountUserData() {
      this.$validator.validateAll().then((result) => {
        if (result && this.uniqEmail) {
          EventBus.$emit(
            "saveNewAccountUserData",
            this.accountUserDetails,
            this.accountUserIndex
          );
          this.newAccountUserData = {
            firstName: "",
            lastName: "",
            designation: "",
            email: "",
            contactNumber: "",
            status: "",
          };
          this.accountUserDetails = this.newAccountUserData;
          // this.$emit("closeAddBaseAccountUserPopup");
        } else {
          if (!this.uniqEmail) {
            this.$message.error("Please provide a unique email id");
          } else {
            this.$message.error("Required fields are missing");
          }
        }
      });
    },
    updateAccountUserData() {
      console.log(this.accountUserDetails);
      this.$validator.validateAll().then((result) => {
        if (result) {
          EventBus.$emit(
            "updatedAccountUserData",
            this.accountUserDetails,
            this.accountUserIndex
          );
          this.$emit("closeEditBaseAccountUserPopup");
          this.accountUserDetails = {
            firstName: "",
            lastName: "",
            designation: "",
            email: "",
            contactNumber: "",
            access_level: "",
            access_region: "",
            access_subregion: "",
            status: "",
          };
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("./BaseAccountUserDetailsPopup.scss");
</style>
<style>
.email {
  text-transform: none !important;
}
</style>
